/// <reference path="~/js/viz/shared/views/NoDataView.js"/>

(function() {
  var ns;

  ns = window.nspace("ccc.viz.profile.views");

  /**
   * A friendly no data message view that appears if a user unselects all checkboxes.
   */
  ns.NoTableDataView = window.ccc.viz.shared.views.NoDataView.extend({
    el: "#data-table-container",
    name: "No table data view",
    templateSelector: "#no-data-table-template"
  });
})();
